// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styes_infoHeader__cxQ16 {
  display: flex;
  gap: 1rem;
  padding: .5rem;
  border-bottom: 1px solid #757575;
}

.styes_actionContainer__verbas__1pYgM {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: white;
  padding: 1.5rem 1rem;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  z-index: 1100;
  transition: margin-left 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, width 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
}

.styes_backActions__actionContainer__n-W0Y {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalAnalisar/styes.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,QAAQ;EACR,OAAO;EACP,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,2CAA2C;EAC3C,aAAa;EACb,4GAA4G;AAC9G;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX","sourcesContent":[".infoHeader {\n  display: flex;\n  gap: 1rem;\n  padding: .5rem;\n  border-bottom: 1px solid #757575;\n}\n\n.actionContainer__verbas {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background: white;\n  padding: 1.5rem 1rem;\n  border-top: 1px solid #e0e0e0;\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);\n  z-index: 1100;\n  transition: margin-left 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, width 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;\n}\n\n.backActions__actionContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoHeader": `styes_infoHeader__cxQ16`,
	"actionContainer__verbas": `styes_actionContainer__verbas__1pYgM`,
	"backActions__actionContainer": `styes_backActions__actionContainer__n-W0Y`
};
export default ___CSS_LOADER_EXPORT___;
